/* jshint esversion: 6 */
import React from 'react';
import ChooserHeader from 'app/components/SubaccountSelector/ChooserHeader.jsx';
import ChooserMain from 'app/components/SubaccountSelector/ChooserMain.jsx';

class GMBOutput extends React.Component {
    render() {
        return (
            <div>
                <ChooserHeader
                    {...this.props}
                    error={this.props.error}
                    headerCopy="Select a Google Business Profile Location"/>
                <ChooserMain
                    {...this.props}
                    noSubaccountMessage={(
                        <p className="chooser-notice no-accounts">
                            We were unable to locate any Google Business Profile locations that can be connected to dlvr.it.<br/><br/>
                            You may have to claim and verify your business. If you've already done this be sure you're logged in to the correct account.<br/><br/>
                            <a href="https://support.google.com/business/answer/2911778" target="_blank">Learn how to claim your business.</a>
                        </p>
                    )}
                    allConnectedMessage={(
                        <p className="chooser-notice">
                            You've already connected all your Google Business Profiles to dlvr.it
                        </p>
                    )}
                    ineligibleMessage={(
                        <p className="chooser-notice">
                            Locations not eligible for posting. <a href="https://support.dlvrit.com/hc/en-us/articles/360019319094-Why-isn-t-dlvr-it-showing-all-of-my-Google-My-Business-locations-" target="_blank">Learn more</a>
                        </p>
                    )}
                    typeLabel="Google Business Profile"/>
            </div>
        );
    }
}

GMBOutput.displayName = "GMBOutput";

export default GMBOutput;
